import { render, staticRenderFns } from "./InsightsDashboard.vue?vue&type=template&id=b0e75f34&scoped=true&"
import script from "./InsightsDashboard.vue?vue&type=script&lang=js&"
export * from "./InsightsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e75f34",
  null
  
)

export default component.exports